import script from "./SideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SideMenu.vue?vue&type=script&setup=true&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=01132382&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01132382"]])

export default __exports__